import { createI18n } from 'vue-i18n';
import type { I18n } from 'vue-i18n';
import { createStorage, setStorage, STORAGE_KEYS } from './storage';
import arMessages from '@/locales/ar.json';

export type Locale = 'en' | 'ar';

let i18n: I18n;

const storage = createStorage<Locale>(STORAGE_KEYS.LOCALE, 'ar');

const loadLocaleMessages = async (locale: Locale) => {
  const messageModule = await import(`@/locales/${locale}.json`);
  i18n.global.setLocaleMessage(locale, messageModule.default);

  // const messages: Record<string, MessageSchema> = {};
  // try {
  //   const locales = import.meta.glob<any>('@/locales/*.json', { eager: true });
  //   Object.entries(locales).forEach(([path, value]) => {
  //     const key = path.match(/([A-Za-z0-9-_]+)\./i)?.[1];
  //     if (key) {
  //       messages[key] = value.default;
  //     }
  //   });
  // } catch (error) {
  //   console.error('Failed to load locale messages:', error);
  // }
  // return messages;
};
export function getLocale() {
  return storage;
}
export async function setLocale(locale: Locale) {
  await loadLocaleMessages(locale);
  if (typeof i18n.global.locale === 'string') {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }
  setStorage(STORAGE_KEYS.LOCALE, locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
}

export function setupI18n() {
  const locale = getLocale();
  i18n = createI18n({
    legacy: false, // Use Composition API mode
    globalInjection: true, // Make $t available in templates
    locale: 'ar',
    fallbackLocale: 'en',
    messages: {
      ar: arMessages, // Load Arabic messages immediately
    },
  });
  locale && setLocale(locale);
  return i18n;
}

export { i18n };
